import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 3.66663C5.60679 3.66663 3.66669 5.60673 3.66669 7.99996C3.66669 10.3932 5.60679 12.3333 8.00002 12.3333C10.3933 12.3333 12.3334 10.3932 12.3334 7.99996C12.3334 5.60673 10.3933 3.66663 8.00002 3.66663ZM2.66669 7.99996C2.66669 5.05444 5.0545 2.66663 8.00002 2.66663C10.9456 2.66663 13.3334 5.05445 13.3334 7.99996C13.3334 10.9455 10.9456 13.3333 8.00002 13.3333C5.05451 13.3333 2.66669 10.9455 2.66669 7.99996Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33335 7.99996C5.33335 7.72382 5.55721 7.49996 5.83335 7.49996H10.1667C10.4428 7.49996 10.6667 7.72382 10.6667 7.99996C10.6667 8.2761 10.4428 8.49996 10.1667 8.49996H5.83335C5.55721 8.49996 5.33335 8.2761 5.33335 7.99996Z"
      fill="currentColor"
    />
  </SvgIcon>
));
